import styled from 'styled-components';

import { Button, Text } from '@gympass/yoga';
import { media } from '@gympass/yoga-helpers';

export const ContentHeader = styled.div`
  background-color: ${({ theme }) => theme.yoga.colors.backgroundLight};
  padding: ${({ theme }) => theme.yoga.spacing.xxlarge}px
    ${({ theme }) => theme.yoga.spacing.huge}px
    ${({ theme }) => theme.yoga.spacing.small}px
    ${({ theme }) => theme.yoga.spacing.huge}px;
  overflow: hidden;
  ${({ theme }) => media.not.md`
    padding: ${theme.yoga.spacing.large}px;
  `}
`;

export const BackButton = styled(Button.Link)`
  position: relative;
  text-align: left;
  display: flex;
  margin-bottom: ${({ theme }) => theme.yoga.spacing.xxlarge}px;
  font-size: ${({ theme }) => theme.yoga.fontSizes.small}px;
  z-index: 2;
  :hover {
    transition: 0s;
    i {
      color: var(--primary-light);
    }
  }
`;

export const BackIcon = styled.i`
  color: ${({ theme }) => theme.yoga.colors.primary};
  cursor: pointer;
  font-size: ${({ theme }) => theme.yoga.fontSizes.medium}px;
  position: relative;
  margin-right: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
  margin-top: -3px;
  z-index: 2;
`;

export const TopicName = styled(Text.Small)`
  position: relative;
  width: ${({ theme }) => theme.yoga.sizes.pageContentWidth}px;
  margin: 0 auto;
  z-index: 2;
  ${media.not.md`
    width: 100%;
  `}
`;

export const HeaderBody = styled.div`
  width: ${({ theme }) => theme.yoga.sizes.pageContentWidth}px;
  margin: 0 auto;
`;

export const Title = styled(Text.H5)`
  position: relative;
  width: ${({ theme }) => theme.yoga.sizes.pageContentTitleWidth}px;
  padding-top: ${({ theme }) => theme.yoga.spacing.small}px;
  z-index: 2;
  ${media.not.md`
    width: 50%;
  `}
`;

export const PinIconsContainer = styled.div`
  position: absolute;
  right: 0px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: var(--content-width);
  top: -${({ theme }) => theme.yoga.sizes.pinSize.top}px;
  overflow: hidden;
  ${({ theme }) => media.not.md`
    width: 100%;
    left: 0px;
    top: -${theme.yoga.sizes.pinSize.top}px;
  `};
`;

export const PinIcon = styled.div`
  width: ${({ theme }) => theme.yoga.sizes.pinSize.width}px;
  height: ${({ theme }) => theme.yoga.sizes.pinSize.height}px;
  margin: 0 ${({ theme }) => theme.yoga.spacing.xxxsmall}px;
  ${({ theme }) => media.not.md`
    width: ${theme.yoga.sizes.pinSize.widthMobile}px;
  `}
`;
